export default "__VITE_ASSET__CuHh0qab__"